"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DropdownHeader", {
    enumerable: true,
    get: function() {
        return DropdownHeader;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
const _Theme = require("../../../contexts/Theme");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const DropdownHeader = (param)=>{
    let { children, ...props } = param;
    const { colors, spacers } = (0, _Theme.useTheme)();
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("h1", {
        ...props,
        className: _style.default.dynamic([
            [
                "e971334b72a40d2f",
                [
                    spacers.s2,
                    spacers.s5,
                    colors.medium
                ]
            ]
        ]) + " " + (props && props.className != null && props.className || "")
    }, children), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "e971334b72a40d2f",
        dynamic: [
            spacers.s2,
            spacers.s5,
            colors.medium
        ]
    }, "h1.__jsx-style-dynamic-selector{margin:".concat(spacers.s2, " ").concat(spacers.s5, ";cursor:default;text-transform:uppercase;font-weight:500;font-size:10px;line-height:16px;color:").concat(colors.medium, "}")));
};

//# sourceMappingURL=DropdownHeader.js.map